import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { GetAllBrands } from '../../redux/Slices/BrandsSlice'
import notify from '../UseNotification'

const UseAllBrands = () => {
  const limit = 12
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true)
  const [searchLoading, setSearchLoading] = useState(true)
  const [SearchValue, setSearchValue] = useState("")
  const [pageCount, setPageCount] = useState()
  const [allBrands, setallBrands] = useState()

  const { AllBrands } = useSelector(state => state.BrandsReducer)

  //  handle get all brands
  const HandleGetAllBrands = async () => {
    setLoading(true)
    await dispatch(GetAllBrands(`limit=${limit}`))
    setLoading(false)
  }

  // to run get all brands function
  useEffect(() => {
    HandleGetAllBrands()
  }, [])


  // handle get search input value
  const ChangeInputSearch = (e) => {
    setSearchValue(e.target.value)
  }

  // handle dispatch the search brand name
  const handleSearchBrandName = async () => {
    setSearchLoading(true)
    await dispatch(GetAllBrands(`limit=${limit}&name=${SearchValue}`))
    setSearchLoading(false)
  }


  // handle request response
  useEffect(() => {
    if (searchLoading === false) {
      if (AllBrands && AllBrands.data) {
        setallBrands(AllBrands.data)
      }
      if (AllBrands && AllBrands.paginationResult) {
        setPageCount(AllBrands.paginationResult.numberOfPages)
      } else {
        notify("Please check your internet connection", "error")
      }
    }
  }, [searchLoading])



  // handle search input value
  useEffect(() => {
    if (SearchValue === "") {
      HandleGetAllBrands()
    } else {
      handleSearchBrandName()
    }
  }, [SearchValue])


  // handle on press data
  const onPress = async (page) => {
    setLoading(true)
    await dispatch(GetAllBrands(`limit=${limit}&page=${page}`))
    setLoading(false)
  }


  // handle request response
  useEffect(() => {
    if (loading === false) {
      if (AllBrands && AllBrands.data) {
        setallBrands(AllBrands.data)
      }
      if (AllBrands && AllBrands.paginationResult) {
        setPageCount(AllBrands.paginationResult.numberOfPages)
      } else {
        notify("Please check your internet connection", "error")
      }
    }
  }, [loading])





  return [loading, allBrands, pageCount, onPress, SearchValue, ChangeInputSearch]
}

export default UseAllBrands
